import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { IFormFieldUiConfirm } from "../types";

type Props = {
  confirm: IFormFieldUiConfirm;
} & WSModalCustomProps<boolean>;

/**
 * Generic confirm-on-change modal driven by a field's `ui.confirm` spec (e.g.
 * the W-4 "Claiming exempt" confirmation). All copy — title, message and both
 * button labels — comes from the schema; resolving `true` commits the change,
 * `false`/dismiss reverts it (handled by useConfirmFieldChange).
 */
export const ModalConfirmFieldChange: React.FC<Props> = ({
  confirm,
  ...modalProps
}) => (
  <WSModal
    title={confirm.title}
    size="S"
    actions={{
      buttons: [
        {
          kind: "Secondary",
          label: confirm.cancelLabel,
          onClick: () => modalProps.onClose(false)
        },
        {
          label: confirm.confirmLabel,
          onClick: () => modalProps.onClose(true)
        }
      ]
    }}
    {...modalProps}
  >
    <WSList gap="M">
      <WSText.ParagraphSm color="gray600">{confirm.message}</WSText.ParagraphSm>
    </WSList>
  </WSModal>
);

export const useModalConfirmFieldChange = () =>
  useWSModalCustom(ModalConfirmFieldChange);
